import React from "react";
import Header from "../Header/ResponsiveHeader";
import Footer from "../Footer/Footer";

import LoadingOverlay from 'react-loading-overlay';
import { connect } from "react-redux"
import qs from "query-string";

class MainTemplate extends React.Component {
    render() {
        const origin = qs.parse(this.props.location.search).origin;
        return (
            <LoadingOverlay
                active={this.props.showOverlay}
                spinner
            >
                <div className="main-container">
                    {origin === "APP" ? null : <Header />}
                    <div className="content">
                        {this.props.children}
                    </div>
                    {origin === "APP" ? null : <Footer />}
                </div>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    return {
        showOverlay: state.overlay.showOverlay
    };
}

export default connect(mapStateToProps)(MainTemplate);